<template>
  <div
  :class="['crx-input crx-box-input remove-browser-border']">

    <label :class="['crx-label', {'primary--text crx-label--active': localFocussed}, {'crx-label--active': (innerValue || '').toString().length > 0}]">{{ label }}</label>
    
    <textarea 
    type="text" 
    :rows="rows"
    :placeholder="placeholder"
    v-model="innerValue"
    @focus="onFocus"
    @blur="onBlur"
    class="pa-2"
    spellcheck="false" />

  </div>
</template>

<script>
export default {
  props: {
    value: null,
    label: null,
    placeholder: null,
    rows: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      localFocussed: false
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (nv) {
        this.$emit('update:value', nv)
      }
    }
  },
  methods: {
    onFocus (event) {
      event.target.select()
      this.localFocussed = true
    },
    onBlur (event) {
      this.$emit('blur', event)
    }
  }
}
</script>

<style scoped lang="scss">
.remove-browser-border {
  input:focus, textarea:focus, select:focus{
    outline: none;
  }
}
</style>
